// extracted by mini-css-extract-plugin
export default {"lds-heart":"Loading_lds-heart__ID4N9"};